import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const ListWithIconsElement = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  if (!element.items || !Array.isArray(element.items)) {
    return null;
  }

  const defaultIcon = element.defaultIcon || '';
  const iconMargin = `${element.iconMarginTop ?? 0}px ${element.iconMarginRight ?? 0}px ${element.iconMarginBottom ?? 0}px ${element.iconMarginLeft ?? 0}px`;

  return (
    <div className="element-list-with-icons" style={style}>
      {element.items.map((item, index) => {
        let textValue = '';
        let icon = '';
        if (typeof item === 'string') {
          textValue = item;
        } else if (item && typeof item === 'object') {
          textValue = item.text || item.title || '';
          icon = item.icon || '';
        }

        const resolvedIcon = icon || defaultIcon;

        return (
          <div key={index} className="list-with-icons-item">
            {resolvedIcon ? (
              <div className="list-with-icons-icon" style={{ margin: iconMargin }}>
                {resolvedIcon}
              </div>
            ) : (
              <div className="option-icon" style={{ margin: iconMargin }}>✓</div>
            )}
            <div className="option-text">
              {replaceTemplates(textValue)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ListWithIconsElement;
